import { RegionConfiguration } from "modules/i18n/utils/loadRegionConfiguration"
import { RegionCode } from "modules/i18n/config/region"

interface DonationsUrlArgs {
  regionConfig: RegionConfiguration
  regionCode: RegionCode
  /**
   * The `utm_campaign` parameter is used to track the source of the donation.
   */
  campaign: string
}

export const donationsUrl = ({
  regionConfig: { donations },
  regionCode,
  campaign,
}: DonationsUrlArgs) => {
  const destinationRegionCode = donations.region === "self" ? regionCode : donations.region

  return `https://donate.theconversation.com/${destinationRegionCode}?utm_source=theconversation.com&utm_medium=website&utm_campaign=${campaign}`
}
